import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import numeral from "numeral";
import { Loader, Button } from "semantic-ui-react";
import {
  postDataAction,
  getDataAction,
  editDataAction,
} from "../../config/redux/action";
import { InputFieldResponsive } from "../../component/Utils";
import { anggaran as formula } from "../../utils/financeFormula";

export const FormAnggaran = () => {
  const dispatch = useDispatch();
  const [dataInput, setdataInput] = useState({});
  const [isLoading, setisLoading] = useState(true);
  const [isLoadingButton, setisLoadingButton] = useState(false);

  const user = useSelector((state) => state.main.dataUser);
  const filter = useSelector((state) => state.main);
  const dataAnggaran = useSelector(
    (state) => state.anggaranReducer.dataAnggaran
  );

  const disabledInput = user.role < 4;

  useEffect(() => {
    dispatch({
      type: "GET_PATH_URL",
      pathUrl: "anggaran",
    });
  }, []);

  useEffect(() => {
    const date = new Date();
    const year = date.getFullYear();

    setisLoading(true);

    if (disabledInput) {
      if (filter.perusahaanFilter) {
        dispatch(
          getDataAction({
            path: `anggaran?search=year:${filter.yearFilter || year
              },and,month:${filter.monFilter},and,perusahaan_id:${filter.perusahaanFilter
              }`,
            type: "GET_DATA_ANGGARAN",
          })
        );
      }
    } else {
      dispatch(
        getDataAction({
          path: `anggaran?search=year:${filter.yearFilter || year},and,month:${filter.monFilter
            }`,
          type: "GET_DATA_ANGGARAN",
        })
      );
    }
  }, [filter.yearFilter, filter.monFilter, filter.perusahaanFilter]);

  useEffect(() => {
    const data = dataAnggaran ? dataAnggaran.content[0] : null;
    setdataInput({
      ...data,
      pendapatan: data ? data.pendapatan : null,
      bebanPendapatan: data ? data.bebanPendapatan : null,
      bebanPenjualan: data ? data.bebanPenjualan : null,
      bebanAdministrasi: data ? data.bebanAdministrasi : null,
      bebanOperasionalLainnya: data ? data.bebanOperasionalLainnya : null,
      pendapatanLain: data ? data.pendapatanLain : null,
      bebanLain: data ? data.bebanLain : null,
      bebanPenyusutan: data ? data.bebanPenyusutan : null,
      bebanBunga: data ? data.bebanBunga : null,
      bebanPajak: data ? data.bebanPajak : null,
    });
    setisLoading(dataAnggaran && false);
  }, [dataAnggaran]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    const stringFields = ["catatan"];
    let v = value;
    if (stringFields.indexOf(name) < 0) v = parseInt(value);
    setdataInput({
      ...dataInput,
      [name]: v,
    });
  };

  const handleSubmit = () => {
    setisLoadingButton(true);
    const NewDataInput = {
      ...dataInput,
      year: filter.yearFilter,
      month: filter.monFilter,
    };
    if (dataAnggaran.content[0]) {
      const EditDataInput = {
        ...NewDataInput,
        id: dataAnggaran.content[0].id,
        perusahaan: {
          id: dataAnggaran.content[0].perusahaan.id,
        },
      };
      dispatch(
        editDataAction({
          dispatch: "",
          title: "Anggaran",
          path: "anggaran",
          body: EditDataInput,
        })
      ).then(() => {
        setisLoadingButton(false);
      });
    } else {
      dispatch(
        postDataAction({
          dispatch: "",
          title: "Anggaran",
          path: "anggaran",
          body: NewDataInput,
        })
      ).then(() => {
        setisLoadingButton(false);
      });
    }
  };

  if (isLoading) {
    return (
      <div className="w-100 d-flex justify-content-center my-5">
        <Loader active>Loading</Loader>
      </div>
    );
  }

  return (
    <>
      <h3>
        Anggaran - {filter.labelMonth} {filter.yearFilter}
      </h3>
      <hr />
      <div className="mb-3">
        <InputFieldResponsive
          label="Pendapatan"
          inputType={{
            disabled: disabledInput,
            value: dataInput.pendapatan,
            name: "pendapatan",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Beban Pendapatan"
          inputType={{
            disabled: disabledInput,
            value: dataInput.bebanPendapatan,
            name: "bebanPendapatan",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <span className="d-flex">
          <h5>Laba Kotor</h5>
          <h5 className="mt-0 ml-auto">
            Rp. {numeral(formula.labaKotor(dataInput)).format(0, 0)}
          </h5>
        </span>
      </div>
      <hr />
      <div className="mb-3">
        <InputFieldResponsive
          label="Beban Penjualan"
          inputType={{
            disabled: disabledInput,
            value: dataInput.bebanPenjualan,
            name: "bebanPenjualan",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Badan Administrasi & Umum"
          inputType={{
            disabled: disabledInput,
            name: "bebanAdministrasi",
            value: dataInput.bebanAdministrasi,
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Beban Operasional Lainnya"
          inputType={{
            disabled: disabledInput,
            name: "bebanOperasionalLainnya",
            value: dataInput.bebanOperasionalLainnya,
            type: "currency",
          }}
          onChange={handleChange}
        />
        <span className="d-flex">
          <h5>Laba Usaha</h5>
          <h5 className="mt-0 ml-auto">
            Rp. {numeral(formula.labaUsaha(dataInput)).format(0, 0)}
          </h5>
        </span>
      </div>
      <hr />
      <div className="mb-3">
        <InputFieldResponsive
          label="Pendapatan Lain-lain"
          inputType={{
            disabled: disabledInput,
            name: "pendapatanLain",
            value: dataInput.pendapatanLain,
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Beban Lain-lain"
          inputType={{
            disabled: disabledInput,
            name: "bebanLain",
            value: dataInput.bebanLain,
            type: "currency",
          }}
          onChange={handleChange}
        />
        <span className="d-flex">
          <h5>EBITDA</h5>
          <h5 className="mt-0 ml-auto">
            Rp. {numeral(formula.ebitda(dataInput)).format(0, 0)}
          </h5>
        </span>
      </div>
      <hr />
      <div className="mb-3">
        <InputFieldResponsive
          label="Beban Penyusutan"
          inputType={{
            disabled: disabledInput,
            name: "bebanPenyusutan",
            value: dataInput.bebanPenyusutan,
            type: "currency",
          }}
          onChange={handleChange}
        />
        <span className="d-flex">
          <h5>EBIT</h5>
          <h5 className="mt-0 ml-auto">
            Rp. {numeral(formula.ebit(dataInput)).format(0, 0)}
          </h5>
        </span>
      </div>
      <hr />
      <div className="mb-3">
        <InputFieldResponsive
          label="Beban Bunga"
          inputType={{
            disabled: disabledInput,
            name: "bebanBunga",
            value: dataInput.bebanBunga,
            type: "currency",
          }}
          onChange={handleChange}
        />
        <span className="d-flex">
          <h5>PBT</h5>
          <h5 className="mt-0 ml-auto">
            Rp. {numeral(formula.pbt(dataInput)).format(0, 0)}
          </h5>
        </span>
      </div>
      <hr />
      <div className="mb-3">
        <InputFieldResponsive
          label="Beban Pajak"
          inputType={{
            disabled: disabledInput,
            name: "bebanPajak",
            value: dataInput.bebanPajak,
            type: "currency",
          }}
          onChange={handleChange}
        />
        <span className="d-flex">
          <h5>Laba Bersih</h5>
          <h5 className="mt-0 ml-auto">
            Rp. {numeral(formula.labaBersih(dataInput)).format(0, 0)}
          </h5>
        </span>
      </div>
      <hr />
      <div className="mb-3">
        <InputFieldResponsive
          label="Catatan"
          inputType={{
            disabled: disabledInput,
            type: "textarea",
            name: "catatan",
            value: dataInput.catatan,
          }}
          onChange={handleChange}
        />
      </div>
      {!disabledInput && (
        <Button
          onClick={handleSubmit}
          color="blue"
          disabled={isLoadingButton}
          loading={isLoadingButton}
        >
          Simpan
        </Button>
      )}
    </>
  );
};
